export default __webpack_public_path__ + "static/media/MtDoomMe.234b356b.jpg";